import { memo } from "react";
const FacilityImages = memo(({photos,defaultImg,name}) => {
  const renderImages = () => {
    // load default image if no photos
    if(!photos.length) {
        return (<img src={defaultImg} alt="default" loading="lazy" width="170" height="123"
      />)
    }
    return photos.map((photo,index) => {
        // show only the first two photos
        if(index <= 1){
          return  (
          <img
            src={photo}
            alt={name + 'photo' + index}
            width="170"
            loading="lazy"
            height="123"
            key={photo}/>)
        } 
        return null
    });
  };
  return (
    <div className={`info-block-list__img ${photos.length > 1 && 'has-multiple'}`}>
      {renderImages()}
    </div>)
});

export default FacilityImages;
